import { create } from 'zustand';

/**
 * Состояние обмена для интерфейса. Счётчики очереди берутся напрямую из Dexie
 * живым запросом — здесь только то, чего в базе нет: фаза, ошибка, время попыток.
 */

export type SyncPhase =
  | 'idle' // всё отправлено
  | 'sending' // отправляем прямо сейчас
  | 'pulling' // забираем справочники
  | 'waiting' // ждём следующей попытки после сбоя
  | 'offline' // сети нет
  | 'unauthorized' // сессия кончилась, нужен повторный вход
  | 'error'; // сервер отказал, нужен человек

interface SyncState {
  online: boolean;
  phase: SyncPhase;
  attempt: number;
  lastError: string | null;
  lastPushAt: string | null;
  lastPullAt: string | null;
  nextAttemptAt: string | null;
  storagePersisted: boolean | null;

  setOnline(online: boolean): void;
  setPhase(phase: SyncPhase): void;
  setError(message: string | null): void;
  setAttempt(attempt: number, nextAttemptAt: string | null): void;
  markPushed(): void;
  markPulled(): void;
  setStoragePersisted(value: boolean): void;
}

export const useSyncStore = create<SyncState>((set) => ({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  phase: 'idle',
  attempt: 0,
  lastError: null,
  lastPushAt: null,
  lastPullAt: null,
  nextAttemptAt: null,
  storagePersisted: null,

  setOnline: (online) => set({ online }),
  setPhase: (phase) => set({ phase }),
  setError: (lastError) => set({ lastError }),
  setAttempt: (attempt, nextAttemptAt) => set({ attempt, nextAttemptAt }),
  markPushed: () => set({ lastPushAt: new Date().toISOString(), lastError: null, attempt: 0, nextAttemptAt: null }),
  markPulled: () => set({ lastPullAt: new Date().toISOString() }),
  setStoragePersisted: (storagePersisted) => set({ storagePersisted }),
}));
